<template>
  <appTable
    v-if="shouldRenderConfig && getIsSummaryPageOptionActive"
    :tableName="name"
    :tableClass="getClassName"
  >
    <div :class="getClassName">
      <div
        v-for="(item, index) in getSummarySelectedPageOptions"
        :key="index"
        :class="getClassNameContainer"
      >
        <div
          v-if="getSummarySelectedPageOptions.length > 1"
          :class="getClassName + 'Header'"
        >
          {{ item.name }}
        </div>
        <div
          v-for="(attribute, indexS) in item.data"
          :key="indexS"
          :class="getClassNameItem"
        >
          <div :class="getClassNameItem + 'Idx'">
            {{ indexS }}
          </div>
          <div :class="getClassNameItem + 'Value'">
            {{ attribute }}
          </div>
          <div class="matrix_separator"></div>
        </div>
      </div>
    </div>
  </appTable>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { i18n } from "../../i18n.js";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, [
      "getSummarySelectedPageOptions",
      "getIsSummaryPageOptionActive"
    ]),
    name: () => {
      return i18n.t("Product overview");
    }
  }
};
</script>
